module.exports = __webpack_public_path__ + "media/news/Bildschirmfoto-2021-03-04-um-16.36.00-31fc8420.webp";